import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

import Tabs from '~/components/Tabs'
import { ZID_INTEGRATION_UPDATE_PATH } from '~/constants/routes'
import { INTEGRATION_TABS } from '~/constants/tabs'

function ZidIntegrationUpdateTabs () {
  const navigate = useNavigate()
  const { guid, tab } = useParams()
  const onChange = (event, tab) => {
    const redirect = generatePath(ZID_INTEGRATION_UPDATE_PATH, { guid, tab })

    navigate(redirect, { replace: true })
  }

  const tabs = [
    { value: INTEGRATION_TABS.GENERAL, label: 'General' },
    { value: INTEGRATION_TABS.LOGS, label: `Logs` }
  ]

  return (
    <Tabs
      tabs={tabs}
      value={tab}
      onChange={onChange}
    />
  )
}

export default ZidIntegrationUpdateTabs
